import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

export const Logout = () => {
  const { logout } = useAuth0();
  logout({ returnTo: window.location.origin });

  return <div>Logging you out...</div>;
};
